import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Table, TableBody } from "@material-ui/core";
import t from "../../languages/pl";
import useStyles from "./styles";
import GroupRow from "./GroupRow";
import CarsInGroupDialog from './GroupDetailsDialog/CarsInGroupDialog';
import ActionCreator from './../../store/actions/index';
import ConfirmationDialog from "./../Common/ConfirmationDialog";
import PaperContainer from '../Common/PaperContainer';
import TableContainerWithHeight from '../Common/TableContainerWithHeight';
import AddGroup from './AddGroup';
import TableHeaderWithTooltip from '../Common/TableHeaderWithTooltip';
import { useWindowSize } from '../../utils/hooks/useWindowResize';
import { countHeightWhen2HeightToolbarUsed } from '../../utils/helpers';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import Warning from '@material-ui/icons/Warning';

const makeDialogText = (name, newState) => {
    switch (name) {
        case t.mpr.toLowerCase():
            return `${newState ? t.turnOn : t.turnOff} ${t.mprExplanation}`.toLowerCase();
        case t.mpp.toLowerCase():
            return `${newState ? t.turnOn : t.turnOff} ${t.mppExplanation}`.toLowerCase();
        case t.mnu.toLowerCase():
            return `${newState ? t.turnOn : t.turnOff} ${t.mnuExplanation}`.toLowerCase();
        case t.mprpu.toLowerCase():
            return `${newState ? t.turnOn : t.turnOff} ${t.mpruExplanation}`.toLowerCase();
        case t.reserve.toLowerCase():
            return `${newState ? t.turnOn : t.turnOff} ${t.fuelReserveExplanation}`.toLowerCase();
        case t.przekroczenie_granicy.toLowerCase():
            return `${newState ? t.turnOn : t.turnOff} ${t.borderCrossExplanation}`.toLowerCase();
        default:
            return newState ? t.turnOn.toLowerCase() : t.turnOff.toLowerCase();
    }
};

const initialGroup = {
    grupa_id: "",
    grupa_nazwa: "",
    grupa_opis: "",
    grupa_usuwalna: true
};

const tableColumns = [
    {columnName: t.name, tooltipText: ''},
    {columnName: t.description, tooltipText: ''},
    {columnName: t.mpr, tooltipText: t.mprExplanation},
    {columnName: t.mpp, tooltipText: t.mppExplanation},
    {columnName: t.mnu, tooltipText: t.mnuExplanation},
    {columnName: t.mprpu, tooltipText: t.mpruExplanation},
    {columnName: t.fuelReserve, tooltipText: t.fuelReserveExplanation, icon: <LocalGasStationIcon /> },
    {columnName: t.borderCross, tooltipText: t.borderCrossExplanation, icon: <Warning /> },
    {columnName: t.carsInGroup, tooltipText: ''},
    {columnName: t.manage, tooltipText: ''},
];

const GroupsTable = (props) => {
    const classes = useStyles();
    const { groups, cars } = props;
    const [open, setOpen] = useState(false);
    const [changeDialogOpen, setChangeDialog] = useState(false);
    const [showGroup, setShowGroup] = useState(initialGroup);
    const [dataToPass, setDataToPass] = useState(null);
    const [dialogText, setDialogText] = useState("");
    const [groupsNames, setGroupsNames] = useState([]);
    const { height } = useWindowSize();

    useEffect(() => {
        props.getGroups();
    }, []);

    useEffect(() => {
        setGroupsNames(groups.map(group => group.grupa_nazwa));
    }, [groups]);

    const handleShowCarsList = id => {
        props.getCarsInGroup(id);
        let group = groups.find(group => group.grupa_id === id);
        setShowGroup({...group});
        setOpen(true);
    };

    const handleGroupAdd = (name) => {
        props.addGroup(name);
    };

    const handleSwitchChange = (oldGroup, e) => {
        let newGroup = {
            ...oldGroup,
            [e.target.name]: e.target.checked
        };
        setChangeDialog(true);
        setDataToPass(newGroup);
        setDialogText(makeDialogText(e.target.name, e.target.checked));
    };

    const handleGroupEdit = (id, name, description) => {
        let newGroup = groups.find(group => group.grupa_id === id);
        newGroup.grupa_nazwa = name;
        newGroup.grupa_opis = description;
        props.changeGroupState(newGroup);
        setOpen(false);
    };

    const handleCarAssignSubmit = (groupId, carIds, groupName) => {
        props.patchCarsInGroup(groupId, carIds, groupName);
    };

    return (
        <PaperContainer>
            <div className={classes.row}>
                <AddGroup
                    onSubmit={handleGroupAdd}
                    groupsNames={groupsNames}
                />
            </div>
            <TableContainerWithHeight className={classes.table} height={countHeightWhen2HeightToolbarUsed(height ? height : null)}>
                <Table stickyHeader>
                    <TableHeaderWithTooltip data={tableColumns}/>
                    <TableBody>
                        <GroupRow
                            data={groups}
                            onShowList={handleShowCarsList}
                            onChange={handleSwitchChange}
                        />
                    </TableBody>
                </Table>
            </TableContainerWithHeight>
            <CarsInGroupDialog
                open={open}
                group={showGroup}
                cars={cars}
                onClose={() => setOpen(false)}
                onDelete={(id) => props.deleteGroup(id)}
                onSubmit={handleGroupEdit}
                onCarAssignSubmit={handleCarAssignSubmit}
                groupsNames={groupsNames}
            />
            <ConfirmationDialog
                open={changeDialogOpen}
                onClose={() => setChangeDialog(false)}
                id={dataToPass}
                onSubmit={(group) => props.changeGroupState(group)}
                action={dialogText}
            />
        </PaperContainer>
    );
};

const mapStateToProps = (state) => ({
    groups: state.groupReducer.groups,
    cars: state.groupReducer.cars
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GroupsTable);

GroupsTable.propTypes = {
    //redux
    groups: PropTypes.array,
    cars: PropTypes.array,
    changeGroupState: PropTypes.func,
    deleteGroup: PropTypes.func,
    addGroup: PropTypes.func,
    getGroups: PropTypes.func,
    getCarsInGroup: PropTypes.func,
    patchCarsInGroup: PropTypes.func
};
